import type { Release } from '../releases.ts';

export default {
  version: '0.15.1',
  date: '2026-10-02',
  title: 'Recorder and built-in profiles',
  summary: [
    'Record video on a phone inside PRISM at 720p, 1080p or 4K',
    'Built-in transcode profiles can be changed, removed and restored',
    'Fixed: phone recordings are no longer limited to low quality',
  ],
  features: [
    'Record video on a phone inside PRISM at 720p, 1080p or 4K, with the front or back camera, and review before uploading',
    'Built-in transcode profiles can be changed, removed and restored; a profile a workflow uses cannot be removed',
  ],
  fixes: ['Phone recordings are no longer limited to the low quality of the browser’s own camera capture'],
} satisfies Release;
